import {useParams} from "react-router-dom";
import {useEffect,useState} from "react";
import axios from "axios";
const apiRoot = process.env.MIX_API_ROOT;
import Definition from "./components/specimen/Definition";
import Locality from "./components/specimen/Locality";
import TaxaList from "./components/specimen/TaxaList";
import Tags from "./components/specimen/Tags";

const imagePolicyUrl = 'https://hs.umt.edu/paleo/collections/policies.php';

export default function Specimen() {
    let params = useParams();
    const [specimen,setSpecimen] = useState();
    const [specimenLoading,setSpecimenLoading] = useState(true);

    useEffect(()=>{
        axios.get(apiRoot + '/specimen/' + params.specimenId)
            .then((response)=>{
                setSpecimen(response.data)
                setSpecimenLoading(false)
            })
    },[])

    if(specimenLoading) {
        return (
            <div className="d-flex justify-content-center">
                <div role="status">
                    Loading...
                </div>
            </div>
        )
    }

    const locality = specimen.locality;
    return (
        <div>
            <h2>{specimen.name}</h2>
            <h3>Specimen {specimen.catalog_number}</h3>
            <div className={'row'}>
                <div className={'col-lg-6 content-detail-sec'}>
                    <dl className={'row'}>
                        <Definition dt={'Common Name'} dd={specimen.common_name} />
                        {specimen.collection ?  <Definition dt={'Collection'} dd={specimen.collection.description} /> : null}
                        <Definition dt={'Catalog Number'} dd={specimen.catalog_number} />
                        <Definition dt={'Case Number'} dd={specimen.case_number} />
                    </dl>
                    <h4>Specimen Information</h4>
                    <dl className={'row'}>
                        <Definition dt={'Part'} dd={specimen.part} />
                        <Definition dt={'Counterpart'} dd={specimen.counterpart} />
                        <Definition dt={'SEM'} dd={specimen.sem} />
                        <Definition dt={'Cast/Mold'} dd={specimen.cast_or_mold} />
                    </dl>
                    <TaxaList taxa={specimen.taxa} collection={specimen.collection}/>
                    <Locality data={specimen.locality} />
                </div>

                <div className={'col-lg-6 content-detail-sec'}>
                    <Tags tags={specimen.tags}/>
                    <Images data={specimen.images} />
                    <Remarks data={specimen.remarks} />
                </div>
            </div>
            <div className={'row'}>
                <div className={'col'}>
                    <p><a href={imagePolicyUrl}>Full use policy details.</a></p>
                </div>
                <div className={'col'}>
                    {specimen.images.length > 0 ? <p>
                        <small>
                            All reproductions must include a credit line, as follows:
                            <br />
                            {specimen.catalog_number}, University of Montana Paleontology Center
                        </small>
                    </p>:null}
                </div>
            </div>
        </div>
    )
}

const Images = (props) => {
    const images = props.data.map((image,index) => {
        return (
            <a href={image.original_image} alt={'original image'} target={'_blank'}>
                <img aria-describedby={'remarks'} key={'image-'+index} src={image.scaled_image} className={'mb-3 w-100 d-none d-md-block img-fluid'} />
            </a>
        )
    })
    return images;
}

const Remarks = (props) => {
    const createMarkup = () => {
        return {__html:props.data}
    }
    return <p id="remarks" dangerouslySetInnerHTML={createMarkup()}/>
}
